import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse, apiError } from '../schemas/common.schema';
import { CourseResponseSchema } from './courses.contract';

const c = initContract();

const linkBody = z.object({
  accountId: z.string(),
  courseId: z.string(),
});

export const accountCoursesContract = c.router({
  listAccountCourses: {
    method: 'GET',
    path: '/account-courses',
    query: z.object({
      account_id: z.string(),
      cursor: z.string().optional(),
      limit: z.coerce.number().optional(),
    }),
    responses: { 200: apiResponse(z.array(CourseResponseSchema)), 400: apiError },
  },
  linkCourse: {
    method: 'POST',
    path: '/account-courses/link',
    body: linkBody,
    responses: { 200: apiResponse(z.null()) },
  },
  unlinkCourse: {
    method: 'DELETE',
    path: '/account-courses/link',
    body: linkBody,
    responses: { 204: c.noBody() },
  },
});
